import anime from 'animejs';
import plangridTrackEvents from './amplitudeInit-vanilla';
import * as functions from './functions-vanilla';
import phoneDemoEvents from './phoneDemo';

export const init = () => {
	plangridTrackEvents("product");
  phoneDemoEvents();
	var slideStates = ["slide1","slide2","slide3","slide4"];
	var currentSlide = 0;

	function getNextSlideIndex(incrementer) {
		currentSlide += incrementer;
		var nextSlide = currentSlide < 0 ? 3 : currentSlide % 4;
    currentSlide = currentSlide < 0 ? 3 : currentSlide;
    return nextSlide;
	}

	function setActiveSlides(activeIndex) {
		document.querySelectorAll("#product-page .slide-img, #product-page .slide-copy, #product-page .slide-underline")
			.forEach( function(item) {
				item.classList.remove("active");
			})
		document.querySelectorAll("#product-page ." + slideStates[activeIndex])
			.forEach( function(item) {
				item.classList.add("active");
			})
	}

	document.querySelectorAll(".fa-angle-left")
		.forEach( function(item) {
			item.addEventListener( "click", function() {
				setActiveSlides( getNextSlideIndex( -1 ) );
				resetSlideInterval()
			});
		});


	document.querySelectorAll(".fa-angle-right")
		.forEach( function(item) {
			item.addEventListener( "click", function() {
				setActiveSlides( getNextSlideIndex( 1 ) );
				resetSlideInterval()
			});
		});

	document.querySelectorAll(".hero-points .slide-copy")
		.forEach( function(item) {
			item.addEventListener( "click",  function(e) {
				var element = functions.getClosest( e.target, ".slide-copy");

        var clickedIdx = slideStates.indexOf(element.getAttribute('rel'));
        currentSlide = clickedIdx;

				setActiveSlides(clickedIdx);
				resetSlideInterval();
			});
		});


	document.querySelectorAll(".question")
		.forEach( function(item) {
			item.addEventListener( "click",  function(e){
				e.preventDefault();
      			var element = functions.getClosest( e.target, ".question");
      			element.querySelector(".answer")
      				.classList.toggle("open");
      			element.classList.toggle("open");
      		});
    	});

	var heroInterval;

	function resetSlideInterval() {
		clearInterval(heroInterval);
		heroInterval = setInterval( function() {
			setActiveSlides( getNextSlideIndex( 1 ) );
		}, 5000);
	}

	resetSlideInterval();
}

document.addEventListener("DOMContentLoaded", init);



// WEBPACK FOOTER //
// ./src/assets/js/product.js